import styled from '@mui/material/styles/styled'

export const ChipLabel = styled('span', {
  name: 'ChipLabel',
  slot: 'Root',
  skipSx: true,
})`
  font-weight: 600;
`
